import { createTheme } from '@mui/material/styles';

const dashboardTheme = createTheme({
  palette: {
    primary: { main: '#1b5742', dark: '#123e30', contrastText: '#ffffff' },
    secondary: { main: '#92703c' },
    background: { default: '#f3f6f3', paper: '#ffffff' },
    text: { primary: '#213d32', secondary: '#65766c' },
    divider: '#e2e9e3',
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: "'Segoe UI', Roboto, Arial, sans-serif",
    button: { textTransform: 'none', fontWeight: 600, fontSize: '0.8125rem' },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { borderRadius: 8, minHeight: 38, padding: '8px 16px' } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' }, rounded: { borderRadius: 12 } } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 9, backgroundColor: '#fff' }, notchedOutline: { borderColor: '#d5dfd7' } } },
    MuiInputLabel: { styleOverrides: { root: { fontSize: '0.875rem' } } },
    MuiTableCell: { styleOverrides: { root: { borderColor: '#e8ede8', padding: '15px 18px', fontSize: '0.8125rem' }, head: { fontWeight: 600 } } },
    MuiDialog: { styleOverrides: { paper: { boxShadow: '0 24px 90px #102b302b' } } },
    MuiDialogTitle: { styleOverrides: { root: { fontWeight: 650, borderBottom: '1px solid #e5ebe5', padding: '20px 24px' } } },
    MuiDialogActions: { styleOverrides: { root: { padding: '16px 24px', gap: 8 } } },
    MuiTooltip: { defaultProps: { arrow: true } },
  },
});
export default dashboardTheme;
